export default function scrollToTop() {
  window.scrollTo({
    top: 0,
    behavior: "auto",
  });
}
